import { CircleNode, CircleNodeModel, h } from '@logicflow/core';
import { getEventIconElements } from './eventIcons';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class StartEventView extends CircleNode {
  getShape() {
    const { model } = this.props;
    const { x, y, r, properties } = model;
    const style = model.getNodeStyle();
    const trigger = properties.trigger || '';
    const isInterrupting = properties.isInterrupting;

    const circleAttrs = { cx: x, cy: y, r, ...style };
    if (isInterrupting === false) {
      circleAttrs.strokeDasharray = '5,3';
    }

    return h('g', {}, [
      h('circle', circleAttrs),
      ...getEventIconElements(h, x, y, trigger, false, style.stroke, 1.0),
    ]);
  }
}

class StartEventModel extends CircleNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.r = 18;
    initLabelOffset(this, data, this.r + 14);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'startEvent');
    style.stroke = t.stroke || '#52c41a';
    style.strokeWidth = t.strokeWidth ?? 1.5;
    style.fill = t.fill || '#f6ffed';
    return style;
  }
}

export const StartEvent = {
  type: 'epx:StartEvent',
  view: StartEventView,
  model: StartEventModel,
};
